import { MarketingWin } from './entities';

export class MarketingWinsStore {
  private wins: MarketingWin[];
  constructor() {
    this.wins = [];
  }

  public updateWins = (wins: MarketingWin[]) => {
    this.wins = wins;
  };

  public getWins = (): MarketingWin[] => {
    return this.wins;
  };
}
